import { useTranslation } from "react-i18next";
import { useDeleteProjectMutation } from "@/features/projects/graphql/generated";
import { ModalFileName } from "@/shared/modals";
import { useModal } from "@/shared/utils/hooks/useModal";
import useOrgNavigate from "@/shared/utils/router/useOrgNavigate";
import { useToast } from "@/shared/contexts/toast.context";

const useDeleteProject = () => {
  const [deleteProject, { loading }] = useDeleteProjectMutation();
  const { t } = useTranslation();
  const navigate = useOrgNavigate();
  const { showToast } = useToast();
  const [openConfirmModal] = useModal(ModalFileName.CONFIRM);

  const handleDeleteProject = async (projectId: number) => {
    await deleteProject({
      variables: { id: projectId },
      refetchQueries: ["Projects"],
    });

    showToast({
      message: "Success!",
      description: "Project archived successfully",
      type: "success",
    });

    navigate("/projects");
  };

  const handleConfirmDeleteProject = (projectId: number, modalProps: any) => {
    openConfirmModal({
      title: t("projects.archive_project_title"),
      description: t("projects.archive_project_content"),
      confirmLabel: t("common.archive_confirm"),
      cancelLabel: t("common.cancel"),
      confirmButtonVariant: "destructive",
      onConfirm: () => handleDeleteProject(projectId),
      ...modalProps,
    });
  };

  return { handleDeleteProject, handleConfirmDeleteProject, loading };
};

export default useDeleteProject;
export { useDeleteProject };
